import type { SeccionDeMiEmpresa } from '../services/mi-empresa-service';

export interface DefinicionDeSeccion {
  id: SeccionDeMiEmpresa;
  /** El texto de la pestaña. */
  texto: string;
  titulo: string;
  subtitulo: string;
}

/** Las siete secciones de Mi empresa, en el orden de la maqueta de Melanie (25-oct). */
export const SECCIONES: DefinicionDeSeccion[] = [
  {
    id: 'resumen',
    texto: 'Resumen',
    titulo: 'Mi empresa',
    subtitulo: 'Cómo está configurada tu empresa en Prixia.',
  },
  {
    id: 'usuarios',
    texto: 'Usuarios',
    titulo: 'Usuarios',
    subtitulo: 'Quién usa Prixia en tu empresa.',
  },
  {
    id: 'roles',
    texto: 'Roles',
    titulo: 'Roles',
    subtitulo: 'Qué puede hacer cada persona según su rol.',
  },
  {
    id: 'equipos',
    texto: 'Equipos',
    titulo: 'Equipos',
    subtitulo: 'Cómo se organiza tu equipo comercial.',
  },
  {
    id: 'aprobaciones',
    texto: 'Aprobaciones',
    titulo: 'Aprobaciones',
    subtitulo: 'Cuándo una cotización necesita aprobación y quién la firma.',
  },
  {
    id: 'documentos',
    texto: 'Documentos',
    titulo: 'Documentos',
    subtitulo: 'Cómo se ven los documentos que tu empresa envía a sus clientes.',
  },
  {
    id: 'pagos',
    texto: 'Pagos y facturación',
    titulo: 'Pagos y facturación',
    subtitulo: 'Tu medio de pago, tus datos de facturación y tus facturas.',
  },
];

/** Cada pestaña tiene su dirección, también el Resumen: la miga dice «Mi empresa / Resumen». */
export const rutaDeSeccion = (id: SeccionDeMiEmpresa) => `/mi-empresa/${id}`;

export const esSeccion = (v: string | undefined): v is SeccionDeMiEmpresa =>
  SECCIONES.some((s) => s.id === v);

/** Las iniciales de una persona: «Roberto Méndez» → «RM». */
export function iniciales(nombre: string, apellido = ''): string {
  const partes = `${nombre} ${apellido}`.trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return '?';
  if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
  return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
}

const DIA_MS = 86_400_000;

/** «hoy», «ayer», «hace 3 días», «hace 2 meses», «nunca». */
export function haceCuantoEntro(iso: string | null, ahora = Date.now()): string {
  if (!iso) return 'nunca';
  const t = new Date(iso);
  const hoy = new Date(ahora);
  const dias = Math.floor(
    (Date.UTC(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()) -
      Date.UTC(t.getFullYear(), t.getMonth(), t.getDate())) /
      DIA_MS
  );
  if (dias <= 0) return 'hoy';
  if (dias === 1) return 'ayer';
  if (dias < 30) return `hace ${dias} días`;
  const meses = Math.floor(dias / 30);
  return meses === 1 ? 'hace 1 mes' : `hace ${meses} meses`;
}
